import mainTheme, { buildTheme, darkTheme, mergeThemes } from './theme';
import pickActiveAccent from './pickActiveAccent';

/**
 * Skin fields AppWrapper places on the app theme beside the mainTheme tokens.
 * Build replaces the app theme with its own provider, so these have to be
 * carried across explicitly or TV mode loses the organisation's primary colour.
 * The skin's darknessMode (`isDarkMode`) is deliberately not carried: the
 * per-user Appearance setting decides Build's mode.
 */
export const SKIN_THEME_FIELDS = [
  'colorAccent',
  'colorPrimary',
  'colorSecondary',
  'isAccentDarkTheme',
  'isPrimaryDarkTheme',
  'isSecondaryDarkTheme',
];

/** Only the defined skin fields, so an absent skin never shadows a key with undefined. */
export const pickSkinFields = (theme = {}) => SKIN_THEME_FIELDS.reduce((acc, key) => (
  theme[key] === undefined ? acc : { ...acc, [key]: theme[key] }
), {});

/**
 * The theme Build renders under. Precedence, lowest first: mainTheme, the
 * skin fields, buildTheme (light high-contrast), darkTheme when dark, then the
 * active-rail accent chosen for this mode.
 */
const composeBuildTheme = ({ isDark, skinAccent, skinFields = {} }) => {
  const accentLayer = { colors: { iconActive: pickActiveAccent(skinAccent, isDark) } };
  return isDark
    ? mergeThemes(mainTheme, skinFields, buildTheme, darkTheme, accentLayer)
    : mergeThemes(mainTheme, skinFields, buildTheme, accentLayer);
};

export default composeBuildTheme;
